module.exports = __webpack_public_path__ + "img/wh2.d1b8a284.png";